import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

/**
 * @file util.ts
 * @author markJia(markjia@tencent.com)
 */
export var SELECT_MAX_COUNT_NODE_KEY = '__SHOW_ITEMS_COUNT__';
export var getDisplayItems = function getDisplayItems(props) {
  var displayItems = props.displayItems,
      maxTagCount = props.maxTagCount;

  if (maxTagCount == null) {
    return displayItems;
  }

  var nextDisplayItems = _toConsumableArray(displayItems);

  var showCount = maxTagCount === 'responsive' ? 1 : maxTagCount;
  var restTagCount = displayItems.length - showCount;
  nextDisplayItems = displayItems.slice(0, showCount);

  if (restTagCount > 0) {
    nextDisplayItems.push({
      id: SELECT_MAX_COUNT_NODE_KEY,
      value: SELECT_MAX_COUNT_NODE_KEY,
      label: "+".concat(restTagCount, "...")
    });
  }

  return nextDisplayItems;
};